import { Flex, Modal, Typography } from "antd"
import { useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import WithdrawalsHistoryTable from "./WithdrawalsHistoryTable"

import "./WithdrawalsHistory.less"

const { Text } = Typography

export const WithdrawalsHistoryModal = ({ open, close }) => {
  const isMobile = useSelector((state) => state.nav.isMobile)

  return (
    <Modal
      open={open}
      onClose={close}
      onCancel={close}
      title={
        <Flex vertical gap={8}>
          <Text className="title">Withdrawal history</Text>
          <Text type="secondary" strong>
            View all your past balance withdrawals, including dates, amounts, and statuses.
          </Text>
        </Flex>
      }
      footer={null}
      closeIcon={<Icon type="cross_small" />}
      rootClassName="withdrawals-history-modal clear-bg"
      classNames={{
        content: "clear-bg"
      }}
      width={isMobile ? "100%" : 750}
      centered={!isMobile}
      wrapClassName={isMobile ? "withdrawals-history-modal--mobile" : ""}
      getContainer={
        isMobile ? document.body : () => document.querySelector(".referral-outsiders-layout")
      }
      destroyOnClose
    >
      <WithdrawalsHistoryTable />
    </Modal>
  )
}

export default WithdrawalsHistoryModal
